module.exports = __webpack_public_path__ + "static/media/volume-slash.aa4b6391.svg";